import { IResourcePlannerStoreValue } from './ResourcePlannerStore.types';

export const INITIAL_RP_STORE: IResourcePlannerStoreValue = {
  dateEnd: new Date(),
  filterList: [],
  selectedViewOptions: {},
};
